import axios from 'axios'
import {message} from 'antd'
import storageUtils from "../utils/storageUtils";
import memoryUtils from "../utils/memoryUtils";

/**
 * 能发送ajax异步请求的函数模块
 * 封装axios库
 * 函数的返回值是promise对象
 */
export default function ajax(url , data={} , type='GET' ) {

    return new Promise((resolve,reject) => {
        let promise;
        //1、执行异步ajax请求
        if(type==='GET'){
            promise = axios.get(url,{
                params: data,
                withCredentials: true,
                crossDomain:true
            });
        }else if(type==='DELETE'){
            promise = axios.delete(url,{
                withCredentials: true,
                crossDomain:true
            });
        }else if(type==='PUT'){
            promise = axios.put(url,data, {
                withCredentials: true,
                crossDomain:true
            });
        }else {
            promise = axios.post(url,data,{
                withCredentials: true,
                crossDomain:true,
            });
        }
        //2、如果成功，调用resolve
        promise.then(response => {
            resolve(response.data);
        //3、如果失败，不调用reject,而是提示异常信息
        }).catch(err => {
            // console.log(err.response);
            if(err.response.status===401){
                storageUtils.removeUser();
                memoryUtils.user = {};
                window.location.replace("/login");
            }else {
                if(err.response.data.msg!==null){
                    message.error(err.response.data.msg);
                    return Promise.reject(err.response.data);
                }
            }
        })
    });
}